import { ConfigurationColors } from '@tink/config/src/tinkLinkConfig';

type Props = Partial<Pick<ConfigurationColors, 'primaryColor'>>;

export const SignUpIcon = ({ primaryColor }: Props) => (
  <svg width="26" height="46" viewBox="0 0 26 46" fill="none">
    <rect x="1" y="1" width="24" height="44" rx="2.604" stroke={primaryColor} strokeWidth="1.5" />
    <rect x="8" y="3" width="10" height="2" rx="1" fill={primaryColor} />
    <path
      d="M12.5004 17.172C13.8369 17.172 14.9203 16.0888 14.9203 14.7526C14.9203 13.4164 13.8369 12.3333 12.5004 12.3333C11.164 12.3333 10.0806 13.4164 10.0806 14.7526C10.0806 16.0888 11.164 17.172 12.5004 17.172Z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6668 20.5339C15.6053 21.6448 14.1306 22.3333 12.5002 22.3333C10.8698 22.3333 9.39501 21.6448 8.3335 20.5338C8.79819 18.603 10.4874 17.1721 12.5001 17.1721C14.5129 17.1721 16.2021 18.603 16.6668 20.5339Z"
      fill={primaryColor}
    />
    <circle cx="12.5" cy="16.5" r="7" stroke={primaryColor} />
    <rect x="3.5" y="26.5" width="19" height="5" rx="1.5" stroke={primaryColor} />
    <rect x="3.5" y="33.5" width="19" height="5" rx="1.5" stroke={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="10" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="13" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <circle cx="7" cy="36" r="1" fill={primaryColor} />
    <path
      d="M6.2533 29.7437L6.73351 29.1253L6 28.9248L6.12665 28.5125L6.83905 28.8078L6.79156 28H7.20844L7.16095 28.8078L7.87335 28.5125L8 28.9248L7.26121 29.1253L7.7467 29.7437L7.41425 30L6.99736 29.3259L6.58575 30L6.2533 29.7437Z"
      fill={primaryColor}
    />
    <path
      d="M9.2533 29.7437L9.73351 29.1253L9 28.9248L9.12665 28.5125L9.83905 28.8078L9.79156 28H10.2084L10.1609 28.8078L10.8734 28.5125L11 28.9248L10.2612 29.1253L10.7467 29.7437L10.4142 30L9.99736 29.3259L9.58575 30L9.2533 29.7437Z"
      fill={primaryColor}
    />
    <path
      d="M12.2533 29.7437L12.7335 29.1253L12 28.9248L12.1266 28.5125L12.8391 28.8078L12.7916 28H13.2084L13.1609 28.8078L13.8734 28.5125L14 28.9248L13.2612 29.1253L13.7467 29.7437L13.4142 30L12.9974 29.3259L12.5858 30L12.2533 29.7437Z"
      fill={primaryColor}
    />
    <path
      d="M15.2533 29.7437L15.7335 29.1253L15 28.9248L15.1266 28.5125L15.8391 28.8078L15.7916 28H16.2084L16.1609 28.8078L16.8734 28.5125L17 28.9248L16.2612 29.1253L16.7467 29.7437L16.4142 30L15.9974 29.3259L15.5858 30L15.2533 29.7437Z"
      fill={primaryColor}
    />
    <path
      d="M18.2533 29.7437L18.7335 29.1253L18 28.9248L18.1266 28.5125L18.8391 28.8078L18.7916 28H19.2084L19.1609 28.8078L19.8734 28.5125L20 28.9248L19.2612 29.1253L19.7467 29.7437L19.4142 30L18.9974 29.3259L18.5858 30L18.2533 29.7437Z"
      fill={primaryColor}
    />
  </svg>
);
